/**
 * Coup de pouce, Attendu 1227 « simplifier des expressions littérales »
 * (3e, Calcul littéral, l. 795). Seconde passe 3e (2026-09-13). UNE page
 * STATIQUE partagée par les trois clés.
 *
 * L'image que l'élève a déjà : les termes triés par nature (4e, réduire une
 * somme ; fiche 1109 « une somme : des paquets »). 3x + 4 + 2x : les
 * termes en x en bleu, le nombre seul en orange ; je regroupe ce qui va
 * ensemble, 3x + 2x = 5x, le 4 reste seul ; résultat 5x + 4. La
 * vérification vise l'erreur principale (5x + 4 = 9x, termes non
 * semblables fusionnés).
 *
 * SACRIFIÉ : les trois termes {3x, 4, 2x} dans tous les ordres (gen_1227,
 * gen1227.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const boite = (x, y, w, couleur, texte, taille = 18) => `<rect x="${x - w / 2}" y="${y - 20}" width="${w}" height="30" rx="7" fill="none" stroke="${couleur}" stroke-width="1.4"/>
  <text x="${x}" y="${y + 2}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${texte}</text>`;
const fleche = (x1, y1, x2, y2, couleur) => `<path d="M ${x1} ${y1} Q ${(x1 + x2) / 2} ${(y1 + y2) / 2 + 18} ${x2} ${y2}" fill="none" stroke="${couleur}" stroke-width="1.4" stroke-dasharray="4 3"/>`;

const SVG = svg(
    '3x plus 4 plus 2x. Les termes en x sont en bleu : 3x et 2x. Le nombre seul est en orange : 4. Les x ensemble : 3x plus 2x égale 5x. Le 4 reste seul, il n’y a pas d’autre nombre. Résultat : 5x plus 4. 5x et 4 ne s’ajoutent pas : ce n’est pas 9x.',
    `<!-- 1. l'expression, chaque terme dans sa couleur -->
  ${boite(110, 44, 52, BLEU, '3x')}
  <text x="150" y="48" font-size="18" text-anchor="middle" fill="${ENCRE}">+</text>
  ${boite(190, 44, 40, ORANGE, '4')}
  <text x="230" y="48" font-size="18" text-anchor="middle" fill="${ENCRE}">+</text>
  ${boite(270, 44, 52, BLEU, '2x')}

  <!-- 2. le regroupement -->
  ${fleche(110, 62, 150, 96, BLEU)}
  ${fleche(270, 62, 210, 96, BLEU)}
  ${fleche(190, 62, 300, 96, ORANGE)}
  ${ligne(118, `<tspan fill="${BLEU}" font-weight="bold">3x + 2x = 5x</tspan>`, 16)}
  <text x="300" y="118" font-size="16" font-weight="bold" text-anchor="middle" fill="${ORANGE}">4</text>
  ${ligne(138, `les <tspan fill="${BLEU}">x</tspan> ensemble`, 11, GRIS)}
  <text x="300" y="138" font-size="11" text-anchor="middle" fill="${GRIS}">reste seul</text>

  <!-- 3. le résultat -->
  ${ligne(178, `3x + 4 + 2x = <tspan fill="${BLEU}" font-weight="bold">5x</tspan> + <tspan fill="${ORANGE}" font-weight="bold">4</tspan>`, 18)}

  <!-- 4. le geste -->
  ${ligne(210, 'Les x ensemble, les nombres ensemble.', 13)}
  ${ligne(232, '5x + 4 s’arrête là : 5x et 4 ne s’ajoutent pas (ce n’est pas 9x).', 12, GRIS)}`,
    248,
);

const AIDE = { pages: [{ titre: 'Les x ensemble, les nombres ensemble', svg: SVG }] };

const CP_1227 = {
    reduire_saisie: AIDE,
    reduire_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1227;
